// extracted by mini-css-extract-plugin
export default {"absBadge":"ClientDocumentList_absBadge__G4+Fo","absIcon":"ClientDocumentList_absIcon__HFlQ9"};